import {
  suppliersResponseSchema, type SuppliersResponse 
} from '../types';
import { ApiClientError } from '@/errors';
import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';

export interface SupplierFilters {
  readonly category?: string;
  readonly search?: string;
}

export async function getSuppliers(filters?: SupplierFilters): Promise<SuppliersResponse> {
  const params = new URLSearchParams();
  if (filters?.category) params.set('category', filters.category);
  if (filters?.search) params.set('search', filters.search);

  const url = buildApiUrl('/v1/suppliers', params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch suppliers');
  }

  return suppliersResponseSchema.parse(await response.json());
}
